import { Button, ButtonProps } from 'primereact/button'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

// local imports
// import heartEmpty from 'assets/icons/heart-empty.svg'
// import heartFilled from 'assets/icons/heart-filled.svg'
import bookmarkEmpty from 'assets/icons/bookmark-empty.svg'
import bookmarkFilled from 'assets/icons/bookmark-filled.svg'

interface CompProps extends ButtonProps {
  onSave?: () => void
  onRemove?: () => void
  isFavorite: boolean
  outlined?: boolean
}

export default function FavoriteIconButton({
  onSave,
  onRemove,
  isFavorite = false,
  outlined = false,
  ...props
}: CompProps) {
  const { t } = useTranslation()
  const iconSrc = isFavorite ? bookmarkFilled : bookmarkEmpty
  const handleClick = isFavorite ? onRemove : onSave
  const titleText = isFavorite ? t('buttons.remove-favorite') : t('buttons.add-favorite')
  const classes = outlined ? 'p-button-outlined' : 'p-button-rounded p-button-text'
  const iconSizes = outlined ? { width: 32, height: 32 } : { width: 22, height: 22 }

  return (
    <FavoriteButton
      {...props}
      className={classes}
      onClick={handleClick}
      {...(outlined ? { height: 54, width: 54 } : {})}>
      <img src={iconSrc} alt="favorite-icon" width={iconSizes.width} height={iconSizes.height} title={titleText} />
    </FavoriteButton>
  )
}

const FavoriteButton = styled(Button)`
  width: ${({ width }: { width?: number; height?: number }) => `${width || 36}px !important`};
  height: ${({ height }: { height?: number }) => `${height || 36}px !important`};
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  // color: #e73932 !important;
  color: #45bfe5 !important;

  :focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: none;
    background-color: none;
  }

  :hover {
    // background: rgba(231, 57, 50, 0.1) !important;
    background: rgba(0, 0, 0, 0.05) !important;
  }

  :disabled {
    opacity: 0.4;
  }
`
